{
  "title": "Kazakhtelecom – бизнес әлеміндегі сіздің серіктесіңіз",
  "description": "АО «Қазақтелеком» ұсынатын интернет пен телефония. Таңбалау, ФДО, сондай-ақ бизнеске арналған цифрлық қызметтер мен IT-шешімдер.",
  "Частным лицам": "Жеке тұлғаларға",
  "Бизнесу": "Бизнеске",
  "Ещё": "Тағы",
  "О компании": "Компания туралы",
  "Гос. заказчикам": "Мемлекеттік тапсырыс берушілерге",
  "Корпоративным клиентам": "Корпоративтік клиенттерге",
  "Операторам": "Операторларға",
  "Партнёрам": "Серіктестерге",
  "Вопросы по ОФД, Маркировке, КГД": "ФДО, Маркалау, МКК бойынша сұрақтар",
  "Справочный центр": "Анықтама орталығы",
  "Подключить": "Қосу",
  "Оплата за услуги": "Қызметтерге төлем",
  "Поддержка": "Қолдау көрсету",
  "Домены": "Домендер",
  "Починить интернет": "Интернетті жөндеу",
  "Личный кабинет": "Жеке кабинет",
  "Пакеты услуг для бизнеса": "Бизнеске арналған қызметтер жиынтығы",
  "Для ИП и самозанятых": "ЖК және өзін-өзі жұмыспен қамтығандар үшін",
  "Для юридических лиц": "Заңды тұлғалар үшін",
  "Как подключить услугу": "Қызметті қалай қосуға болады",
  "Выберите услугу": "Қызметті таңдаңыз",
  "Проверим адрес": "Мекенжайды тексереміз",
  "Подключим услугу": "Қызметті қосамыз",
  "Оставьте заявку\nна подключение": "Қосылуға өтінім қалдырыңыз",
  "Подтвердим\nдоступность по адресу": "Мекенжай бойынша қолжетімділікті растаймыз",
  "Выполним установку\nи настройку": "Орнатамыз және реттейміз",
  "Сервисы для бизнеса": "Бизнеске арналған сервистер",
  "Телевидение нового поколения для бизнеса": "Бизнеске арналған жаңа буын теледидары",
  "Ваш бизнес в одной ссылке": "Бизнесіңіз бір сілтемеде",
  "Соберите контакты, соцсети, сайт и предложения в одну страницу, которой удобно делиться с клиентами": "Байланыс деректерін, әлеуметтік желілерді, сайтты және ұсыныстарды клиенттерге бөлісуге ыңғайлы әрі жинақы профильге біріктіріңіз",
  "Создать страницу": "Парақша жасау",
  "Простое подключение, богатый выбор контента": "Оңай қосылу, контенттің мол таңдауы",
  "Все сервисы": "Барлық сервистер",
  "Создайте свою link in bio\nстраницу": "Өзіңіздің link in bio парақшаңызды жасаңыз",
  "Новости и обновления": "Жаңалықтар мен жаңартулар",
  "Все новости": "Барлық жаңалықтар",
  "Интернет": "Интернет",
  "IT-Решения": "IT-Шешімдер",
  "Маркировка": "Таңбалау",
  "Облачные и цифровые\nсервисы, аренда серверов,\nхостинг, IT-услуги": "Бұлтты және цифрлық қызметтер, серверлерді жалға беру, хостинг, IT-қызметтер",
  "Маркировка кодом Data Matrix": "Data Matrix кодымен маркалау",
  "Подписывайте,\nотправляйте\nи получайте\nдокументы онлайн": "Құжаттарға онлайн қол қойыңыз, жіберіңіз және қабылдаңыз",
  "Облачная среда\nдля AI-технологий на базе\nNVIDIA H200": "NVIDIA H200 негізіндегі AI технологияларына арналған бұлтты орта",
  "ОФД": "ФДО",
  "Решение для фискального учёта": "Фискалдық есептемеге арналған шешім",
  "Сервис сокращения ссылок": "Сілтемелерді қысқарту қызметі",
  "Поддержка стартапов\nи компаний": "Стартаптар мен компанияларға қолдау",
  "Перейти на сайт": "Сайтқа өту",
  "Документы": "Құжаттар",
  "Сократить ссылку": "Сілтемені қысқарту",
  "Услуги": "Қызметтер",
  "Проекты": "Жобалар",
  "Помощь и поддержка": "Көмек және қолдау көрсету",
  "Заказать звонок": "Қоңырау сұрату",
  "Офисная связь": "Кеңселік байланыс",
  "Служба поддержки": "Қолдау көрсету қызметі",
  "Колл-центр": "Колл-орталығы",
  "Адреса и реквизиты": "Мекенжайлар мен деректемелер",
  "Телевидение": "Теледидар",
  "IT и безопасность": "ІТ және қауіпсіздік",
  "Новости": "Жаңалықтар",
  "Строительство сети": "Желі құрылысы",
  "Оплата": "Төлем",
  "АО «Казахтелеком». Все права защищены": "«Қазақтелеком» АҚ. Барлық құқықтар сақталған",
  "АО «Казахтелеком».\nВсе права защищены": "«Қазақтелеком» АҚ.\nБарлық құқықтар сақталған",
  "Договор оферты": "Оферта шарты",
  "Публичный договор": "Жария шарт",
  "Выбор клиентов": "Клиенттер таңдауы",
  "/ мес": "/ ай",
  "Интернет по оптике": "Оптика бойынша интернет",
  "{speed} Мбит / сек входящая скорость": "Кіріс жылдамдығы {speed} Мбит / сек",
  "{speed} Мбит / сек исходящая скорость": "Шығыс жылдамдығы {speed} Мбит / сек",
  "100+ телеканалов": "100+ телеарналар",
  "2 онлайн кинорума": "2 онлайн кинорум",
  "Связь": "Байланыс",
  "Телефония": "Телефония",
  "SIP-телефония": "SIP-телефония",
  "Мобильная связь": "Ұялы байланыс",
  "5 000 минут на междугородние и городские номера по РК": "ҚР бойынша қалааралық және қалалық нөмірлерге 5 000 минут",
  "1 000 минут звонков на Altel / Tele2": "Altel / Tele2-де 1 000 минуттық қоңыраулар",
  "Безлимитные звонки на Altel / Tele2": "Altel / Tele2-ге шексіз қоңыраулар",
  "6 000 минут на междугородние и городские номера по РК": "ҚР бойынша қалааралық және қалалық нөмірлерге 6 000 минут",
  "800 минут звонков на Kcell / Beeline": "Kcell / Beeline-да 800 минуттық қоңыраулар",
  "400 минут звонков на Kcell / Beeline": "Kcell / Beeline-да 400 минуттық қоңыраулар",
  "40 GB мобильного интернет трафика": "40 ГБ мобильді интернет трафигі",
  "20 GB мобильного интернет трафика": "20 ГБ мобильді интернет трафигі",
  "Бесплатный трафик на WhatsApp, Facebook, Telegram": "WhatsApp, Facebook, Telegram-да тегін трафик",
  "Антивирус": "Антивирус",
  "Антивирус для ПК": "Компьютерге арналған антивирус",
  "Антивирус для мобильных устройств": "Мобильді құрылғыларға арналған антивирус",
  "Антиспам Who Calls": "Who Calls антиспамы",
  "Видеонаблюдение": "Бейнебақылау",
  "1 500 минут звонков на Altel / Tele2": "Altel / Tele2-де 1 500 минуттық қоңыраулар",
  "16 дополнительных услуг связи": "16 қосымша байланыс қызметтері",
  "Каталог услуг": "Қызметтер каталогы",
  "Войти": "Кіру",
  "Вход и регистрация": "Кіру және тіркелу",
  "ЦЭДМ": "ТТЭҚО",
  "НКТ": "ТҰК",
  "НСПТ": "ТҚҰЖ",
  "Подробнее": "Толығырақ",
  "Выбрать услугу": "Қызметті таңдау",
  "Интернет для бизнеса": "Бизнеске арналған интернет",
  "Интернет для игровых клубов": "Ойын клубтарына арналған интернет",
  "Wi-Fi target": "Wi-Fi target",
  "FXS — Городской телефон по оптическому кабелю": "FXS — қалалық оптикалық кабельдік телефон",
  "Универсальный номер для мобильного бизнеса": "Мобильді бизнеске арналған әмбебап нөмір",
  "Голосовой робот-помощник": "Дыбыстық робот-көмекші",
  "Видеонаблюдение IMOU": "Видеобақылау IMOU",
  "TV+ business": "TV+ business",
  "Приватная сеть IP VPN": "IP VPN жеке желісі",
  "Защита от DDoS-атак": "DDoS-шабуылдардан қорғау",
  "Интернет с доступом к кэш-серверам": "Кэш серверлеріне кіру мүмкіндігі бар интернет",
  "Интернет-пиринг": "Интернет-пиринг",
  "Электронный документооборот для бизнеса": "Бизнеске арналған электрондық құжат айналымы",
  "Получение технических условий": "Техникалық шарттарды алу",
  "Cтаньте партнёром АО «Казахтелеком»": "«Қазақтелеком» АҚ-ның серіктесі болыңыз",
  "Личный кабинет корпоративного клиента": "Корпоративтік клиенттің жеке кабинеті",
  "Мобильное приложение": "Мобильді қосымша",
  "Отправить один бумажный документ курьером — дороже, чем месяц подписки на Telecom Docs": "Бір қағаз құжатты курьермен жіберу Telecom Docs қызметінің бір айлық жазылымынан қымбат",
  "Облачная среда для AI-технологий на базе NVIDIA H200. Вычислительные мощности внутри Казахстана": "NVIDIA H200 негізіндегі AI технологияларына арналған бұлтты орта. Есептеу қуаты Қазақстан аумағында орналасқан",
  "Попробовать бесплатно": "Тегін көріңіз",
  "Начать работу": "Жұмысты бастау",
  "О сервисе": "Қызмет туралы",
  "Скачайте приложение": "Қосымшаны жүктеп алыңыз",
  "Отсканируйте QR-код камерой телефона": "QR‑кодты телефон камерасымен сканерлеңіз",
  "Скачайте наше приложение": "Біздің қосымшаны жүктеп алыңыз",
  "Отсканируйте QR-код с помощью камеры вашего устройства или нажмите кнопку ниже, чтобы перейти в магазин приложений": "Өз құрылғыңыздағы камера арқылы QR-кодын сканерлеңіз немесе төмендегі түймешені басып, Қосымшалар дүкеніне өтіңіз",
  "Скачать приложение": "Қосымшаны жүктеу",
  "ОФД Казахтелеком": "ФДО Қазақтелеком",
  "Настройки аккаунта": "Аккаунтты реттеу",

  "Управление компаниями": "Компанияларды басқару",
  "Вход и регистрация": "Кіру және тіркелу",
  "Выберите товарную группу": "Тауар тобын таңдаңыз",
  "Производители, импортёры": "Өндірушілер, импорттаушылар",
  "Оптовые реализаторы, аптеки, медицинские организации": "Көтерме сатушылар, дәріханалар, медициналық ұйымдар",
  "Обувная продукция": "Аяқ киім өнімдері",
  "Вход в ИС МПТ": "ТТҚ АЖ жүйесіне кіру",
  "Заказ кодов, формирование отчёта о нанесении и агрегации": "Кодтарға тапсырыс беру, таңбалау және агрегаттау туралы есепті қалыптастыру",
  "Вход в ИС ЭТ": "ТЭ АЖ жүйесіне кіру",
  "Заказ кодов, формирование отчёта о нанесении, работа с документами": "Кодтарға тапсырыс беру, таңбалау туралы есепті қалыптастыру, құжаттармен жұмыс",
  "Вход в ЦЭДМ": "ТТЭҚО жүйесіне кіру",
  "Работа с документами прослеживаемости": "Қадағаланатын құжаттармен жұмыс",
  "Регистрация в ИС МПТ": "ТТҚ АЖ АЖ жүйесінде тіркелу",
  "Для регистрации в системе требуется ЭЦП и установленный NCALayer": "Жүйеде тіркелу үшін ЭЦҚ және орнатылған NCALayer қажет",
  "Регистрация на b2b.telecom.kz": "b2b.telecom.kz сайтында тіркелу",
  "Работа с бухгалтерскими документами": "Бухгалтерлік құжаттармен жұмыс",
  "Тестовая работа в ИС МПТ": "ТТҚ АЖ жүйесінде сынақ жұмысы",
  "Аппробация процессов маркировки в ИС МПТ: регистрация карточки товара, получение кодов, работа с документами прослеживаемости товара": "ТТҚ АЖ жүйесінде таңбалау үдерістерін сынақтан өткізу: тауар карточкасын тіркеу, кодтарды алу, тауардың қадағаланатын құжаттарымен жұмыс",
  "Бесплатно с мобильных и городских номеров": "Ұялы және қалалық нөмірлерден тегін",
  "Помощник в Telegram": "Telegram-дағы көмекші",
  "Помощник в WhatsApp": "WhatsApp-дағы көмекші",
  "Лекарственные препараты": "Дәрілік заттар",
  "Табачные изделия": "Темекі өнімдері",
  "Товары лёгкой промышленности": "Жеңіл өнеркәсіп тауарлары",
  "Моторные масла": "Майлау материалдары",
  "Вход в систему": "Жүйеге кіру",
  "Вход в тестовую систему": "Тестілеу жүйесіне кіру",
  "Ювелирные изделия": "Зергерлік бұйымдар",
  "Пиво и пивные напитки": "Сыра және сыра сусындары",
  "Биологически активные добавки": "Биологиялық белсенді қоспалар",
  "Бытовая химия": "Тұрмыстық химия",
  "banner": {
    "docs": {
      "title": "Telecom Docs-ты қолданып көріңіз тегін",
      "description": "Карта мен жазылымды енгізбей-ақ 3 құжатты тегін жіберіңіз",
      "button": "Тегін бастаңыз"
    }
  },
  "Цифровые сервисы": "Цифрлық қызметтер",
  "Инфраструктура дронов под ключ": "Дрон инфрақұрылымы — дайын шешім",
  "Цифровой сервис телемедицины": "Сандық телемедицина қызметі",
  "Смарт-видеожетоны": "Смарт-видеожетондар",
  "Умные остановки": "Ақылды аялдамалар",
  "Интернет вещей (IoT)": "Заттар интернеті (IoT)",
  "ИИ-агенты для бизнеса": "Бизнеске арналған ЖИ‑агенттер",
  "Baylanis — платформа видеоконференций": "Baylanis — бейнеконференция платформасы",
  "ИИ для анализа КТ головного мозга": "Ми КТ-сын талдауға арналған ЖИ",
  "Облачные сервисы": "Бұлтты қызметтер",
  "Объектное хранилище S3": "S3 нысандық сақтау",
  "Виртуальный хостинг": "Виртуалды хостинг",
  "Виртуальный выделенный сервер (VPS)": "Виртуалды арнайы сервер (VPS)",
  "Домены .KZ .ҚАЗ": "KZ. ҚАЗ. домендері",
  "Виртуальный дата-центр (VDC)": "Виртуалды деректер орталығы (VDC)",
  "Сервисы ЦОД": "ДӨО қызметтері",
  "Размещение оборудования (Colocation)": "Жабдықты орналастыру (Colocation)",
  "Аренда серверной стойки (Rent a rack)": "Сервер тірегін жалға алу (Rent a rack)",
  "Развитие бизнеса": "Бизнесті дамыту",
  "Все услуги": "Барлық қызметтер",
  "Газовые баллоны": "Газ баллондары",
  "Растительное масло": "Өсімдік майы",
  "Древесина": "Ағаш материалдары",
  "Изделия медицинского назначения": "Медициналық мақсаттағы бұйымдар",
  "Дериваты сайгаков": "Киік туындылары",
  "Оплата по QR на столе, заказы и бронирование": "Тапсырыс беру, брондау және QR арқылы төлеу",
  "Подключите Halyk Рестораны без абонентской платы и обслуживайте гостей быстрее": "Halyk Мейрамханалар қызметіне абоненттік төлемсіз қосылып, қонақтарға жылдамырақ қызмет көрсетіңіз",
  "Узнать о сервисе": "Қызмет туралы толығырақ",
  "Магазинам и аптекам\nвыгоднее с OnlineDuken": "Дүкендер мен дәріханаларға OnlineDuken-пен тиімдірек",
  "Заказывайте товары у проверенных поставщиков, получайте до 50 000 бонусов в месяц, оплачивайте покупку сразу или с отсрочкой на сумму до 5 млн ₸": "Сенімді жеткізушілерден тапсырыс беріңіз. Айына 50 000-ға дейін бонус алыңыз. Сатып алуды бірден немесе 5 млн ₸ дейін кейінге қалдырылған төлеммен жасаңыз.",
  "Оставить заявку": "Өтінім қалдыру",
  "Интернет для платёжных терминалов PayNet": "PayNet төлем терминалдарына арналған интернет",
  "Стабильное подключение для работы платёжных терминалов": "Төлем терминалдарының тұрақты жұмысына арналған интернет"
}
